<template>
  <div>
    <v-data-table
      :loading="isSearching"
      :headers="headers"
      :items="searchResults"
      :expand="expand"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr @click="props.expanded = !props.expanded">
          <td>{{ props.item.title }}</td>
          <td v-if="$vuetify.breakpoint.mdAndUp">{{ abbreviateKey(props.item.key) }}</td>
          <td v-if="$vuetify.breakpoint.mdAndUp">{{ props.item.arranger }}</td>

          <td v-if="$vuetify.breakpoint.mdAndUp">
            <v-rating dense small readonly v-model="props.item.rating"></v-rating>
          </td>

          <td v-if="$vuetify.breakpoint.mdAndUp" class="text-xs-right">
            <v-icon class="mr-2" v-if="props.item.dots">picture_as_pdf</v-icon>
            <v-icon
              class="mr-2"
              v-if="props.item.bari || props.item.bass || props.item.lead || props.item.tenor || props.item.all"
            >library_music</v-icon>
            <v-icon @click="share(props.item.id)">share</v-icon>
          </td>

          <td v-else class="text-xs-right">
            <span class="mr-2">
              {{ props.item.rating }}
              <v-icon small>star</v-icon>
            </span>

            <v-icon small class="mr-2" v-if="props.item.dots">picture_as_pdf</v-icon>
            <v-icon
              small
              class="mr-2"
              v-if="props.item.bari || props.item.bass || props.item.lead || props.item.tenor || props.item.all"
            >library_music</v-icon>
            <v-icon @click="share(props.item.id)">share</v-icon>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>Use the box above to search for tags!</template>

      <template v-slot:expand="props">
        <Tag :item="props.item"></Tag>
      </template>
    </v-data-table>

    <v-snackbar v-model="showLinkCopied" top color="primary">Copied link to clipboard!</v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Tag from "./Tag.vue";

export default {
  components: {
    Tag
  },

  data() {
    return {
      showLinkCopied: false,

      expand: false,

      mdHeaders: [
        { text: "Title", value: "title" },
        { text: "Key", value: "key" },
        { text: "Arranger", value: "arranger" },
        { text: "Rating", value: "rating" },
        { text: "", value: "", width: "25%", align: "right" }
      ],

      smHeaders: [
        { text: "Title", value: "title" },
        { text: "", value: "", align: "right", width: "39%" }
      ]
    };
  },

  computed: {
    ...mapGetters(["searchResults", "isSearching"]),

    headers() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return this.mdHeaders;
      }

      return this.smHeaders;
    }
  },

  methods: {
    abbreviateKey(key) {
      let sig = key.split(":");
      if (sig.length === 1) {
        return "-";
      }

      return sig[1] + sig[0].slice(0, 3).toLowerCase();
    },

    share(id) {
      this.$copyText(`https://tags.thesheps.dev/#/tag/${id}`);
      this.showLinkCopied = true;
    }
  }
};
</script>